<template>
  <section class="single-cat">
    <article>
      <div class="row clearfix">
        <h1>
          Festivals (Contemporary Music)
          <!-- <a href="javascript:;" data-table="category-trends-table" class="infotoggle inline tooltipstered">Click for more info</a> -->
        </h1>
        <div class="sixcol">
          <p><strong>Festivals (Contemporary Music)</strong> recorded $399.9m in revenue and over 2.1m attendances in 2025. These results are the highest-ever recorded for this category.</p>
          <p><strong>Festivals (Contemporary Music)</strong> recorded a y-o-y increase in revenue of 20.7% (from $331.3m in 2024 to $399.9m in 2025) and a y-o-y increase in attendance of 4.9% (from 2.0m in 2024 to 2.1m in 2025).</p>
          <p>The growth in revenue and attendance is partially driven by the return in 2025 of festivals that did not proceed in 2024, such as Spilt Milk.</p>
          <p>The average ticket price increased by 14.1% y-o-y (from $180.75 in 2024 to $206.17 in 2025), to offset rising production and touring costs, which further contributed to the growth in revenue.</p>
          <p><strong>Festivals (Contemporary Music)</strong> contributed 11.9% to the total industry share of revenue and 6.9% to the total attendance in 2025. The revenue was primarily driven by festivals such as Beyond The Valley, Bluesfest, Knockout Outdoor 2025: Return of the Circuz, Spilt Milk, Laneway Festival, Hypersonic Festival, CMC Rocks and Good Things Festival.</p>
        </div>
        <div class="sixcol last">
          <p>In 2025, NSW, VIC and QLD generated the most revenue and attendance in this category. These three states generated 83.0% of overall revenue and 80.6% of attendance in this category in 2025.</p>
          <p>All states and territories except NSW, VIC, WA and ACT recorded a y-o-y decline in revenue and attendance in 2025.</p>
          <p>ACT recorded the highest y-o-y growth in revenue and attendance in 2025, primarily due to the return of Spilt Milk festival. However, its impact was limited as ACT contributed only 3.2% of overall revenue and 2.7% of overall attendance in this category.</p>
          <p>NSW recorded a y-o-y growth of 30.6% in revenue and 17.2% in attendance, while VIC recorded y-o-y growth of 35.7% in revenue and 13.8% in attendance. WA also recorded a y-o-y growth in both revenue and attendance, with revenue increasing by 15.9% and attendance increasing by 14.7%, supported by festivals such as Spilt Milk, Wildlands, Strummingbird and Touch Bass Festival.</p>
        </div>
      </div>
    </article>

    <figure class="chart">
      <div class="row clearfix">
        <highcharts class="graphcontainer" :options="totalRevenueAttendance"></highcharts>
      </div>
    </figure>

    <figure id="classical-music-states" class="chart">
      <div class="row clearfix">
        <h1>State/Territory Breakdown</h1>

        <div class="chart-wrapper">
          <highcharts class="graphcontainer" :options="activeStateBreakdown"></highcharts>
          <div class="nb">NB: Numbers may not total 100.0% due to rounding.<br>Categories/States with zero or &lt;0.05% of revenue and/or attendance<br> may not be reflected in the pie chart.</div>
        </div>
      </div>
    </figure>

    <div class="row clearfix">
      <h2 id="download-btn">Download the Report</h2>
      <div class="execsumm" style="justify-content: center;">
        <a href="./pdf/2025/FESTIVALS (CONTEMPORARY MUSIC)  Live Performance Industry in 2025.pdf" class="button fullreport pdf" target="_blank">
          Festivals (Contemporary Music) Infographic Report 2025 (PDF)
        </a>
      </div>
    </div>

    <div class="fullbg">
      <p class="caption">Photo: <em>Field Day Festival</em>, Fuzzy, Photo Credit: Jordan Munns</p>
    </div>
  </section>
</template>

<script>
/*eslint-disable */

export default {
  data () {
    return {
      totalRevenueAttendance: {
        chart: {
          backgroundColor: null,
        },
        title: {
          text: ''
        },
        xAxis: [{
          categories: ["2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
          labels: {
            style: {
              color: '#fff'
            }
          }
        }],
        yAxis: [{ // Primary yAxis
          min: 0,
          labels: {
            formatter: function() {
              if (this.value > 999) {
                return '$' + (this.value / 1000) + 'b'
              } else {
                return '$' + this.value + 'm'
              }
            },
            style: {
              color: '#fff'
            }
          },
          title: {
            text: 'Gross Revenue',
            style: {
              color: '#fff'
            }
          },
          opposite: true
        }, { // Secondary yAxis
          min: 0,
          labels: {
            formatter: function() {
              if (this.value < 1) {
                return (this.value * 1000) + 'k'
              } else {
                return this.value + 'm'
              }
            },
            style: {
              color: '#fff'
            }
          },
          title: {
            text: 'Total Attendance',
            style: {
              color: '#fff'
            }
          },
          opposite: false
        }],
        tooltip: {
          shared: true,
          formatter: function() {
            let revy, tooltipstring;
            let rev = this.points[0];
            let att = this.points[1];
            let atty = att.y + 'm';
            let chart = this.points[0].series.chart;
            let categories = chart.xAxis[0].categories;
            let index = 0;
            while (this.x !== categories[index]) {
              index++;
            }
            if (rev.y > 1000) {
              revy = '$' + (rev.y / 1000).toFixed(2) + 'b'
            } else {
              revy = '$' + rev.y + 'm'
            }
            if (att.y < 1) {
              atty = (att.y * 1000).toFixed(0) + 'k'
            } else {
              atty = att.y + 'm'
            }

            tooltipstring = this.x + '<br />';
            tooltipstring += '<span style="color:' + rev.series.color + '">•</span> Revenue: ' + revy + '<br />'
            tooltipstring += '<span style="color:' + att.series.color + '">•</span> Attendance: ' + atty + '<br />'
            return tooltipstring
          }
        },
        legend: {
          layout: 'vertical',
          align: 'center',
          verticalAlign: 'bottom',
          floating: false,
          backgroundColor: '#FFFFFF'
        },
        series: [{
          name: 'Revenue',
          type: 'column',
          data: [9.015, 12.128, 36.577, 26.972, 66.429, 55.276, 100.918, 96.453, 98.365, 107.368, 129.21, 106.825, 79.865, 100.657, 102.016, 180.853, 54.175, 51.280, 234.41, 355.083, 331.292, 399.885],
          color: '#3a89eb'
        }, {
          name: 'Attendance',
          type: 'column',
          yAxis: 1,
          data: [0.19, 0.269, 0.762, 0.753, 1.222, 0.8, 1.028, 0.985, 1.169, 1.053, 1.281, 1.3, 0.673, 0.853, 0.975, 1.448, 0.437, 0.462, 1.537, 2.03, 2.011, 2.109],
          color: '#d14967'
        }]
      },
      activeYear: 2025,
      stateBreakdowns: [
        {
          year: 2025,
          revenue: [
            ["NSW", 35.2],
            ["VIC", 31.6],
            ["QLD", 16.2],
            ["WA", 7.0],
            ["SA", 4.7],
            ["ACT", 3.18],
            ["TAS", 1.6],
            ["NT", 0.5],
          ],
          attendance: [
            ["NSW", 37.2],
            ["VIC", 27.0],
            ["QLD", 16.4],
            ["WA", 8.5],
            ["SA", 5.6],
            ["ACT", 2.71],
            ["TAS", 1.7],
            ["NT", 0.8],
          ]
        }
      ],
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  computed: {
    activeStateBreakdown () {
      const self = this

      for (let i = 0; i < self.stateBreakdowns.length; i++) {
        const stateBreakdown = self.stateBreakdowns[i]
        if (stateBreakdown.year === self.activeYear) {
          return {
            chart: {
              type: 'pie',
              backgroundColor: 'transparent'
            },
            title: {
              text: ''
            },
            subtitle: {
              text: ''
            },
            plotOptions: {
              series: {
                states: {
                  inactive: {
                    opacity: 1
                  }
                }
              },
              pie: {
                shadow: false,
                center: ['50%', '50%'],
                dataLabels: {
                  enabled: true,
                  style: {
                    fontWeight: 'bold',
                    color: 'white',
                    textShadow: '0px 1px 2px black'
                  }
                },
                point: {
                  events: {
                    legendItemClick: e => {
                      e.preventDefault();
                      return false;
                    }
                  }
                }
              }
            },
            legend: {
              align: 'right',
              layout: 'vertical',
              verticalAlign: 'middle',
              itemMarginBottom: 10,
              itemStyle: {
                color: '#fff'
              },
              itemHoverStyle: {
                color: '#fff'
              }
            },
            tooltip: {
              valueSuffix: '%',
              valueDecimals: 1
            },
            series: [
              {
                name: 'Attendance Share',
                data: stateBreakdown.attendance,
                size: '68%',
                innerSize: '40%',
                borderColor: 'none',
                borderWidth: 1,
                slicedOffset: 30,
                showInLegend: true,
                dataLabels: {
                  color: '#000',
                  style: {
                    textShadow: 'none',
                  },
                  formatter: function() {
                    if (this.y > 3) {
                      return this.y.toFixed(1) + '% '
                    }
                  },
                  distance: -28
                }
              }, 
              {
                name: 'Revenue Share',
                data: stateBreakdown.revenue,
                size: '100%',
                innerSize: '70%',
                borderColor: 'transparent',
                borderWidth: 1,
                dataLabels: {
                  color: '#000',
                  style: {
                    textShadow: 'none',
                  },
                  formatter: function() {
                    if (this.y > 3) {
                      return this.y.toFixed(1) + '% '
                    }
                  },
                  distance: -32
                }
              }
            ],
            colors: [
              '#f66262',
              '#f2914a',
              '#5fa62b',
              '#6598d3',
              '#594ebb',
              '#bc56c3',
              '#c3567f',
              '#edc055'
            ]
          }
        }
      }

      return false
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
.single-cat {
  background-image: url("~@/assets/img/2025/24-Festivals-(Contemp-Music)-Fuzzy_FieldDay_2025_CreditJordanMunns_2.jpg");
}
.chart-wrapper {
  position: relative;
  .nb {
    position: absolute;
    bottom: 0;
    right: 0;
    color: #fff;
    font-style: italic;
    font-size: 12px;
  }
}
</style>
